import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MaterialConfirmDialogComponent } from './material-confirm-dialog.component';

export interface DialogRequest {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  tone?: 'default' | 'danger';
  requireNotes?: boolean;
  notesLabel?: string;
}

@Injectable({ providedIn: 'root' })
export class DialogService {
  constructor(private matDialog: MatDialog) {}

  /**
   * Opens a confirmation dialog and normalizes the close result.
   * @param options Dialog title, message, buttons, tone, and optional notes requirement.
   * @returns Promise resolving to confirmation state and optional notes.
   */
  confirm(options: DialogRequest): Promise<{ confirmed: boolean; notes?: string }> {
    return this.matDialog
      .open(MaterialConfirmDialogComponent, {
        width: 'min(460px, calc(100vw - 28px))',
        data: options,
        autoFocus: options.requireNotes ? 'textarea' : 'dialog',
        restoreFocus: true
      })
      .afterClosed()
      .toPromise()
      .then((result) => result || { confirmed: false });
  }
}
